export const requiredOptionsToInjectMask = {
    projectName: 0x1,
    stand: 0x2,
};
export const requiredOptionsToRunMask = {
    scriptIncluded: 0x4,
};
